import {
  FETCH_PVS_CATEGORY_REQUEST,
  FETCH_PVS_CATEGORY_SUCCESS,
  FETCH_PVS_CATEGORY_FAILURE,
  RESET_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchPvsCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PVS_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case FETCH_PVS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Categories fetched successfully",
      };

    case FETCH_PVS_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to fetch categories",
      };

    case RESET_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchPvsCategoryReducer;
